export default "__VITE_ASSET__DPjVXEjs__"